// extracted by mini-css-extract-plugin
export var circle = "_2z-2";
export var icon = "_2z-a";
export var iconHighlight = "_2z-0";
export var lg = "_2z-8";
export var md = "_2z-7";
export var outline = "_2z-4";
export var sm = "_2z-6";
export var square = "_2z-1";
export var xl = "_2z-9";
export var xs = "_2z-5";
export var xxs = "_2z-3";